<template>
    <b-modal
        id="assignment-show-statistic-modal"
        :title="$t('assignment.assignment_overview')"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.close')"
        size="lg">
        <design-2021-apprentice-data-table
            class="statistics-table"
            :fields="fields"
            :items="portfolioData">
            <template #options>
                <div class="students">
                    <h3 class="title">{{ $t('assignment.participants') }}</h3>
                    <ul class="list-unstyled">
                        <li
                            class="student"
                            v-for="student of students">
                            <i class="fad fa-user"></i><span class="name">{{ student }}</span>
                        </li>
                    </ul>
                </div>
            </template>

            <template #cell(deadline)="row">
                <div
                    class="deadline-date"
                    v-if="row.item.deadline">
                    {{ row.item.deadline | date_time_om }}
                </div>
            </template>

            <template #cell(date)="row">
                <div
                    class="status-date"
                    v-if="row.item.date">
                    {{ row.item.date | date_time_om }}
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import Design2021ApprenticeDataTable from '../../../common/design-2021-apprentice-data-table';

export default {
    name: 'design-2021-assignment-show-statistics-model-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        assignmentIn: Object,
        studentsIn: String,
    },
    data() {
        return {
            students: this.studentsIn.split(','),
            assignment: this.assignmentIn,
            fields: [
                {
                    key: 'title',
                    label: this.$t('common.name'),
                },
                {
                    key: 'deadline',
                    label: 'Deadline',
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'status',
                    label: 'Status',
                },
                {
                    key: 'date',
                    label: 'Datum',
                },
            ],
        };
    },
    mounted() {
        this.portfolioData;
    },
    computed: {
        portfolioData() {
            const data = this.assignment.sub_assignments.map((sub_assignment) => {
                return {
                    title: sub_assignment.name,
                    deadline:
                        sub_assignment.deadlines.length > 0 ? sub_assignment.deadlines[0].agenda_item.date_time : null,
                    type: this.$t('assignment.sub_assignment'),
                    status: sub_assignment.hasStatus() ? this.getStatus(sub_assignment) : 'Open',
                    date: sub_assignment.hasStatus() ? sub_assignment.statuses[0].created_at : null,
                };
            });

            data.unshift({
                title: this.assignment.name,
                deadline:
                    this.assignment.deadlines.length > 0 ? this.assignment.deadlines[0].agenda_item.date_time : null,
                type: this.$t('assignment.main_assignment'),
                status: this.assignment.hasStatus() ? this.getStatus(this.assignment) : 'Open',
                date: this.assignment.hasStatus() ? this.assignment.statuses[0].created_at : null,
            });

            return data ? data : [];
        },
    },
    methods: {
        getStatus(portfolio) {
            if (portfolio.getStatus().isInSubmittedState()) {
                return this.$t('assignment.submitted');
            }
            if (portfolio.getStatus().isInReopenedState()) {
                return this.$t('assignment.reopened');
            }
            if (portfolio.getStatus().isInClosedState()) {
                return this.$t('assignment.closed');
            }
        },
    },
    watch: {
        assignmentIn: function (value) {
            this.assignment = value;
        },
    },
};
</script>

<style scoped lang="scss">
.statistics-table ::v-deep {
    .apprentice-table-header {
        flex-direction: column;
    }
}

.students {
    flex: 1;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 0;

        .student {
            width: 50%;
            margin-bottom: map-get($grid-gutter-spacing, 'ten');

            i {
                margin-right: map-get($grid-gutter-spacing, 'eight');
                color: $primary;
                font-size: 1.125rem;
            }

            .name {
                color: $text-muted-color;
                font-weight: $font-weight-medium;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .statistics-table ::v-deep {
        .apprentice-table-header {
            .search {
                .input-group {
                    width: 210px;
                }
            }
        }
    }

    .students {
        ul {
            justify-content: flex-start;

            .student {
                width: auto;

                &:not(:last-child) {
                    margin-right: $grid-gutter-width;
                }
            }
        }
    }
}
</style>
